var AssetsManager,
  __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

AssetsManager = (function(_super) {
  __extends(AssetsManager, _super);

  function AssetsManager(tabs, uploadview) {
    this.toggle_ui = __bind(this.toggle_ui, this);
    this.close_ui = __bind(this.close_ui, this);
    this.open_ui = __bind(this.open_ui, this);
    AssetsManager.__super__.constructor.call(this, {}, tabs);
    Observable(this, 'uploadview', uploadview);
    Observable(this, 'open', false);
    this.uploadview().callback('add', (function(_this) {
      return function(e, data) {
        _this.select_tab(_this.tabs()[0]);
        return _this.open_ui();
      };
    })(this));
    this.loaded.subscribe((function(_this) {
      return function(data) {
        if (data.name === 'Uploads') {
          $('#uploads').show();
          return $('#all-images').hide();
        } else {
          $('#uploads').hide();
          return $('#all-images').show();
        }
      };
    })(this));
  }

  AssetsManager.prototype.open_ui = function() {
    if (!this.open()) {
      return this.toggle_ui(true);
    }
  };

  AssetsManager.prototype.close_ui = function() {
    if (this.open()) {
      return this.toggle_ui(false);
    }
  };

  AssetsManager.prototype.toggle_ui = function(bool) {
    if (bool == null) {
      bool = null;
    }
    $('#tab-assetsmanager').toggleClass('active', bool);
    if (bool === false || $('.assets-manager').hasClass('col-md-6')) {
      this.open(false);
      $('#tab-assetsmanager-icon').switchClass('glyphicon-backward', 'glyphicon-forward');
      return $('.assets-manager').toggle('slide', {}, 400, (function(_this) {
        return function() {
          $('.assets-manager').toggleClass('col-md-6', bool);
          $('.assets-container').toggleClass('col-md-6', bool);
          return $('.assets-container').toggleClass('pull-right', bool);
        };
      })(this));
    } else {
      this.open(true);
      $('#tab-assetsmanager-icon').switchClass('glyphicon-forward', 'glyphicon-backward');
      return $('.assets-container').toggleClass('pull-right', bool).promise().done((function(_this) {
        return function() {
          $('.assets-manager').toggleClass('col-md-6', bool);
          $('.assets-container').toggleClass('col-md-6', bool);
          return $('.assets-manager').toggle('slide');
        };
      })(this));
    }
  };

  return AssetsManager;

})(TabView);

//# sourceMappingURL=assetsmanager.js.map
